module.exports = __webpack_public_path__ + "6f59cb7507711b217e963370bcd4d8df.png";